import oe, { useRef as Ke, useEffect as ur, useCallback as We, useState as cr, useLayoutEffect as $r, useId as Mr } from "react";
import { styled as te } from "styled-components";
var He = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, yr = { exports: {} }, qe = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wr;
function ln() {
  if (Wr) return qe;
  Wr = 1;
  var t = oe, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, o = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, d = { key: !0, ref: !0, __self: !0, __source: !0 };
  function m(w, g, W) {
    var R, j = {}, a = null, l = null;
    W !== void 0 && (a = "" + W), g.key !== void 0 && (a = "" + g.key), g.ref !== void 0 && (l = g.ref);
    for (R in g) i.call(g, R) && !d.hasOwnProperty(R) && (j[R] = g[R]);
    if (w && w.defaultProps) for (R in g = w.defaultProps, g) j[R] === void 0 && (j[R] = g[R]);
    return { $$typeof: e, type: w, key: a, ref: l, props: j, _owner: o.current };
  }
  return qe.Fragment = r, qe.jsx = m, qe.jsxs = m, qe;
}
var $e = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fr;
function un() {
  return Fr || (Fr = 1, process.env.NODE_ENV !== "production" && function() {
    var t = oe, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), d = Symbol.for("react.profiler"), m = Symbol.for("react.provider"), w = Symbol.for("react.context"), g = Symbol.for("react.forward_ref"), W = Symbol.for("react.suspense"), R = Symbol.for("react.suspense_list"), j = Symbol.for("react.memo"), a = Symbol.for("react.lazy"), l = Symbol.for("react.offscreen"), s = Symbol.iterator, u = "@@iterator";
    function f(n) {
      if (n === null || typeof n != "object")
        return null;
      var c = s && n[s] || n[u];
      return typeof c == "function" ? c : null;
    }
    var N = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function V(n) {
      {
        for (var c = arguments.length, v = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          v[y - 1] = arguments[y];
        S("error", n, v);
      }
    }
    function S(n, c, v) {
      {
        var y = N.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", v = v.concat([C]));
        var A = v.map(function(_) {
          return String(_);
        });
        A.unshift("Warning: " + c), Function.prototype.apply.call(console[n], console, A);
      }
    }
    var O = !1, U = !1, se = !1, De = !1, Ue = !1, ve;
    ve = Symbol.for("react.module.reference");
    function be(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === i || n === d || Ue || n === o || n === W || n === R || De || n === l || O || U || se || typeof n == "object" && n !== null && (n.$$typeof === a || n.$$typeof === j || n.$$typeof === m || n.$$typeof === w || n.$$typeof === g || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === ve || n.getModuleId !== void 0));
    }
    function Ze(n, c, v) {
      var y = n.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? v + "(" + C + ")" : v;
    }
    function Be(n) {
      return n.displayName || "Context";
    }
    function B(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && V("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case d:
          return "Profiler";
        case o:
          return "StrictMode";
        case W:
          return "Suspense";
        case R:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case w:
            var c = n;
            return Be(c) + ".Consumer";
          case m:
            var v = n;
            return Be(v._context) + ".Provider";
          case g:
            return Ze(n, n.render, "ForwardRef");
          case j:
            var y = n.displayName || null;
            return y !== null ? y : B(n.type) || "Memo";
          case a: {
            var C = n, A = C._payload, _ = C._init;
            try {
              return B(_(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, me = 0, pe, we, Le, Pe, _e, ze, le;
    function ge() {
    }
    ge.__reactDisabledLog = !0;
    function Qe() {
      {
        if (me === 0) {
          pe = console.log, we = console.info, Le = console.warn, Pe = console.error, _e = console.group, ze = console.groupCollapsed, le = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: ge,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        me++;
      }
    }
    function ke() {
      {
        if (me--, me === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, n, {
              value: pe
            }),
            info: Z({}, n, {
              value: we
            }),
            warn: Z({}, n, {
              value: Le
            }),
            error: Z({}, n, {
              value: Pe
            }),
            group: Z({}, n, {
              value: _e
            }),
            groupCollapsed: Z({}, n, {
              value: ze
            }),
            groupEnd: Z({}, n, {
              value: le
            })
          });
        }
        me < 0 && V("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var he = N.ReactCurrentDispatcher, ye;
    function Ee(n, c, v) {
      {
        if (ye === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            ye = y && y[1] || "";
          }
        return `
` + ye + n;
      }
    }
    var Ce = !1, Oe;
    {
      var vr = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new vr();
    }
    function Se(n, c) {
      if (!n || Ce)
        return "";
      {
        var v = Oe.get(n);
        if (v !== void 0)
          return v;
      }
      var y;
      Ce = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = he.current, he.current = null, Qe();
      try {
        if (c) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (G) {
              y = G;
            }
            Reflect.construct(n, [], _);
          } else {
            try {
              _.call();
            } catch (G) {
              y = G;
            }
            n.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (G) {
            y = G;
          }
          n();
        }
      } catch (G) {
        if (G && y && typeof G.stack == "string") {
          for (var x = G.stack.split(`
`), H = y.stack.split(`
`), F = x.length - 1, D = H.length - 1; F >= 1 && D >= 0 && x[F] !== H[D]; )
            D--;
          for (; F >= 1 && D >= 0; F--, D--)
            if (x[F] !== H[D]) {
              if (F !== 1 || D !== 1)
                do
                  if (F--, D--, D < 0 || x[F] !== H[D]) {
                    var re = `
` + x[F].replace(" at new ", " at ");
                    return n.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", n.displayName)), typeof n == "function" && Oe.set(n, re), re;
                  }
                while (F >= 1 && D >= 0);
              break;
            }
        }
      } finally {
        Ce = !1, he.current = A, ke(), Error.prepareStackTrace = C;
      }
      var Me = n ? n.displayName || n.name : "", xe = Me ? Ee(Me) : "";
      return typeof n == "function" && Oe.set(n, xe), xe;
    }
    function er(n, c, v) {
      return Se(n, !1);
    }
    function Te(n) {
      var c = n.prototype;
      return !!(c && c.isReactComponent);
    }
    function Re(n, c, v) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return Se(n, Te(n));
      if (typeof n == "string")
        return Ee(n);
      switch (n) {
        case W:
          return Ee("Suspense");
        case R:
          return Ee("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case g:
            return er(n.render);
          case j:
            return Re(n.type, c, v);
          case a: {
            var y = n, C = y._payload, A = y._init;
            try {
              return Re(A(C), c, v);
            } catch {
            }
          }
        }
      return "";
    }
    var ae = Object.prototype.hasOwnProperty, ue = {}, Ie = N.ReactDebugCurrentFrame;
    function je(n) {
      if (n) {
        var c = n._owner, v = Re(n.type, n._source, c ? c.type : null);
        Ie.setExtraStackFrame(v);
      } else
        Ie.setExtraStackFrame(null);
    }
    function rr(n, c, v, y, C) {
      {
        var A = Function.call.bind(ae);
        for (var _ in n)
          if (A(n, _)) {
            var x = void 0;
            try {
              if (typeof n[_] != "function") {
                var H = Error((y || "React class") + ": " + v + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw H.name = "Invariant Violation", H;
              }
              x = n[_](c, _, y, v, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (F) {
              x = F;
            }
            x && !(x instanceof Error) && (je(C), V("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", v, _, typeof x), je(null)), x instanceof Error && !(x.message in ue) && (ue[x.message] = !0, je(C), V("Failed %s type: %s", v, x.message), je(null));
          }
      }
    }
    var tr = Array.isArray;
    function $(n) {
      return tr(n);
    }
    function ce(n) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, v = c && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return v;
      }
    }
    function Ae(n) {
      try {
        return T(n), !1;
      } catch {
        return !0;
      }
    }
    function T(n) {
      return "" + n;
    }
    function k(n) {
      if (Ae(n))
        return V("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ce(n)), T(n);
    }
    var p = N.ReactCurrentOwner, I = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Q, J, P;
    P = {};
    function h(n) {
      if (ae.call(n, "ref")) {
        var c = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function ee(n) {
      if (ae.call(n, "key")) {
        var c = Object.getOwnPropertyDescriptor(n, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function Ye(n, c) {
      if (typeof n.ref == "string" && p.current && c && p.current.stateNode !== c) {
        var v = B(p.current.type);
        P[v] || (V('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(p.current.type), n.ref), P[v] = !0);
      }
    }
    function nr(n, c) {
      {
        var v = function() {
          Q || (Q = !0, V("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        v.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: v,
          configurable: !0
        });
      }
    }
    function Gt(n, c) {
      {
        var v = function() {
          J || (J = !0, V("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        v.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: v,
          configurable: !0
        });
      }
    }
    var Kt = function(n, c, v, y, C, A, _) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: n,
        key: c,
        ref: v,
        props: _,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Jt(n, c, v, y, C) {
      {
        var A, _ = {}, x = null, H = null;
        v !== void 0 && (k(v), x = "" + v), ee(c) && (k(c.key), x = "" + c.key), h(c) && (H = c.ref, Ye(c, C));
        for (A in c)
          ae.call(c, A) && !I.hasOwnProperty(A) && (_[A] = c[A]);
        if (n && n.defaultProps) {
          var F = n.defaultProps;
          for (A in F)
            _[A] === void 0 && (_[A] = F[A]);
        }
        if (x || H) {
          var D = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          x && nr(_, D), H && Gt(_, D);
        }
        return Kt(n, x, H, C, y, p.current, _);
      }
    }
    var br = N.ReactCurrentOwner, kr = N.ReactDebugCurrentFrame;
    function Ve(n) {
      if (n) {
        var c = n._owner, v = Re(n.type, n._source, c ? c.type : null);
        kr.setExtraStackFrame(v);
      } else
        kr.setExtraStackFrame(null);
    }
    var mr;
    mr = !1;
    function pr(n) {
      return typeof n == "object" && n !== null && n.$$typeof === e;
    }
    function Cr() {
      {
        if (br.current) {
          var n = B(br.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Xt(n) {
      return "";
    }
    var Rr = {};
    function Zt(n) {
      {
        var c = Cr();
        if (!c) {
          var v = typeof n == "string" ? n : n.displayName || n.name;
          v && (c = `

Check the top-level render call using <` + v + ">.");
        }
        return c;
      }
    }
    function Ir(n, c) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var v = Zt(c);
        if (Rr[v])
          return;
        Rr[v] = !0;
        var y = "";
        n && n._owner && n._owner !== br.current && (y = " It was passed a child from " + B(n._owner.type) + "."), Ve(n), V('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', v, y), Ve(null);
      }
    }
    function jr(n, c) {
      {
        if (typeof n != "object")
          return;
        if ($(n))
          for (var v = 0; v < n.length; v++) {
            var y = n[v];
            pr(y) && Ir(y, c);
          }
        else if (pr(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var C = f(n);
          if (typeof C == "function" && C !== n.entries)
            for (var A = C.call(n), _; !(_ = A.next()).done; )
              pr(_.value) && Ir(_.value, c);
        }
      }
    }
    function Qt(n) {
      {
        var c = n.type;
        if (c == null || typeof c == "string")
          return;
        var v;
        if (typeof c == "function")
          v = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === g || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === j))
          v = c.propTypes;
        else
          return;
        if (v) {
          var y = B(c);
          rr(v, n.props, "prop", y, n);
        } else if (c.PropTypes !== void 0 && !mr) {
          mr = !0;
          var C = B(c);
          V("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && V("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function en(n) {
      {
        for (var c = Object.keys(n.props), v = 0; v < c.length; v++) {
          var y = c[v];
          if (y !== "children" && y !== "key") {
            Ve(n), V("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        n.ref !== null && (Ve(n), V("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Ar = {};
    function Vr(n, c, v, y, C, A) {
      {
        var _ = be(n);
        if (!_) {
          var x = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var H = Xt();
          H ? x += H : x += Cr();
          var F;
          n === null ? F = "null" : $(n) ? F = "array" : n !== void 0 && n.$$typeof === e ? (F = "<" + (B(n.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : F = typeof n, V("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", F, x);
        }
        var D = Jt(n, c, v, C, A);
        if (D == null)
          return D;
        if (_) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if ($(re)) {
                for (var Me = 0; Me < re.length; Me++)
                  jr(re[Me], n);
                Object.freeze && Object.freeze(re);
              } else
                V("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jr(re, n);
        }
        if (ae.call(c, "key")) {
          var xe = B(n), G = Object.keys(c).filter(function(sn) {
            return sn !== "key";
          }), wr = G.length > 0 ? "{key: someKey, " + G.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ar[xe + wr]) {
            var an = G.length > 0 ? "{" + G.join(": ..., ") + ": ...}" : "{}";
            V(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, wr, xe, an, xe), Ar[xe + wr] = !0;
          }
        }
        return n === i ? en(D) : Qt(D), D;
      }
    }
    function rn(n, c, v) {
      return Vr(n, c, v, !0);
    }
    function tn(n, c, v) {
      return Vr(n, c, v, !1);
    }
    var nn = tn, on = rn;
    $e.Fragment = i, $e.jsx = nn, $e.jsxs = on;
  }()), $e;
}
process.env.NODE_ENV === "production" ? yr.exports = ln() : yr.exports = un();
var L = yr.exports, cn = typeof He == "object" && He && He.Object === Object && He, dn = typeof self == "object" && self && self.Object === Object && self;
cn || dn || Function("return this")();
var dr = typeof window < "u" ? $r : ur;
function Nr(t, e, r, i) {
  const o = Ke(e);
  dr(() => {
    o.current = e;
  }, [e]), ur(() => {
    const d = window;
    if (!(d && d.addEventListener))
      return;
    const m = (w) => {
      o.current(w);
    };
    return d.addEventListener(t, m, i), () => {
      d.removeEventListener(t, m, i);
    };
  }, [t, r, i]);
}
function fn(t, e) {
  const r = Ke(t);
  dr(() => {
    r.current = t;
  }, [t]), ur(() => {
    if (e === null)
      return;
    const i = setInterval(() => {
      r.current();
    }, e);
    return () => {
      clearInterval(i);
    };
  }, [e]);
}
function Dr(t) {
  const e = Ke(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return dr(() => {
    e.current = t;
  }, [t]), We((...r) => {
    var i;
    return (i = e.current) == null ? void 0 : i.call(e, ...r);
  }, [e]);
}
var gr = typeof window > "u";
function vn(t, e, r = {}) {
  const { initializeWithValue: i = !0 } = r, o = We(
    (a) => r.serializer ? r.serializer(a) : JSON.stringify(a),
    [r]
  ), d = We(
    (a) => {
      if (r.deserializer)
        return r.deserializer(a);
      if (a === "undefined")
        return;
      const l = e instanceof Function ? e() : e;
      let s;
      try {
        s = JSON.parse(a);
      } catch (u) {
        return console.error("Error parsing JSON:", u), l;
      }
      return s;
    },
    [r, e]
  ), m = We(() => {
    const a = e instanceof Function ? e() : e;
    if (gr)
      return a;
    try {
      const l = window.localStorage.getItem(t);
      return l ? d(l) : a;
    } catch (l) {
      return console.warn(`Error reading localStorage key “${t}”:`, l), a;
    }
  }, [e, t, d]), [w, g] = cr(() => i ? m() : e instanceof Function ? e() : e), W = Dr((a) => {
    gr && console.warn(
      `Tried setting localStorage key “${t}” even though environment is not a client`
    );
    try {
      const l = a instanceof Function ? a(m()) : a;
      window.localStorage.setItem(t, o(l)), g(l), window.dispatchEvent(new StorageEvent("local-storage", { key: t }));
    } catch (l) {
      console.warn(`Error setting localStorage key “${t}”:`, l);
    }
  }), R = Dr(() => {
    gr && console.warn(
      `Tried removing localStorage key “${t}” even though environment is not a client`
    );
    const a = e instanceof Function ? e() : e;
    window.localStorage.removeItem(t), g(a), window.dispatchEvent(new StorageEvent("local-storage", { key: t }));
  });
  ur(() => {
    g(m());
  }, [t]);
  const j = We(
    (a) => {
      a.key && a.key !== t || g(m());
    },
    [t, m]
  );
  return Nr("storage", j), Nr("local-storage", j), [w, W, R];
}
var bn = typeof window > "u";
function mn(t = {}) {
  const { autoLock: e = !0, lockTarget: r, widthReflow: i = !0 } = t, [o, d] = cr(!1), m = Ke(null), w = Ke(null), g = () => {
    if (m.current) {
      const { overflow: R, paddingRight: j } = m.current.style;
      if (w.current = { overflow: R, paddingRight: j }, i) {
        const a = m.current === document.body ? window.innerWidth : m.current.offsetWidth, l = parseInt(window.getComputedStyle(m.current).paddingRight, 10) || 0, s = a - m.current.scrollWidth;
        m.current.style.paddingRight = `${s + l}px`;
      }
      m.current.style.overflow = "hidden", d(!0);
    }
  }, W = () => {
    m.current && w.current && (m.current.style.overflow = w.current.overflow, i && (m.current.style.paddingRight = w.current.paddingRight)), d(!1);
  };
  return dr(() => {
    if (!bn)
      return r && (m.current = typeof r == "string" ? document.querySelector(r) : r), m.current || (m.current = document.body), e && g(), () => {
        W();
      };
  }, [e, r, i]), { isLocked: o, lock: g, unlock: W };
}
var Hr = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Ur = oe.createContext && /* @__PURE__ */ oe.createContext(Hr), pn = ["attr", "size", "title"];
function wn(t, e) {
  if (t == null) return {};
  var r = gn(t, e), i, o;
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(t);
    for (o = 0; o < d.length; o++)
      i = d[o], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
  }
  return r;
}
function gn(t, e) {
  if (t == null) return {};
  var r = {};
  for (var i in t)
    if (Object.prototype.hasOwnProperty.call(t, i)) {
      if (e.indexOf(i) >= 0) continue;
      r[i] = t[i];
    }
  return r;
}
function or() {
  return or = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, or.apply(this, arguments);
}
function Br(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function ar(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Br(Object(r), !0).forEach(function(i) {
      hn(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Br(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function hn(t, e, r) {
  return e = yn(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function yn(t) {
  var e = En(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function En(t, e) {
  if (typeof t != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var i = r.call(t, e || "default");
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Gr(t) {
  return t && t.map((e, r) => /* @__PURE__ */ oe.createElement(e.tag, ar({
    key: r
  }, e.attr), Gr(e.child)));
}
function Kr(t) {
  return (e) => /* @__PURE__ */ oe.createElement(On, or({
    attr: ar({}, t.attr)
  }, e), Gr(t.child));
}
function On(t) {
  var e = (r) => {
    var {
      attr: i,
      size: o,
      title: d
    } = t, m = wn(t, pn), w = o || r.size || "1em", g;
    return r.className && (g = r.className), t.className && (g = (g ? g + " " : "") + t.className), /* @__PURE__ */ oe.createElement("svg", or({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, i, m, {
      className: g,
      style: ar(ar({
        color: t.color || r.color
      }, r.style), t.style),
      height: w,
      width: w,
      xmlns: "http://www.w3.org/2000/svg"
    }), d && /* @__PURE__ */ oe.createElement("title", null, d), t.children);
  };
  return Ur !== void 0 ? /* @__PURE__ */ oe.createElement(Ur.Consumer, null, (r) => e(r)) : e(Hr);
}
function Sn(t) {
  return Kr({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M336 192h40a40 40 0 0 1 40 40v192a40 40 0 0 1-40 40H136a40 40 0 0 1-40-40V232a40 40 0 0 1 40-40h40m160-64-80-80-80 80m80 193V48" }, child: [] }] })(t);
}
function Tn(t) {
  return Kr({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" }, child: [] }] })(t);
}
const xn = te.div`
  background-color: rgba(10, 10, 10, 0.5);
  display: ${({ $isVisible: t }) => t ? "block" : "none"};
  left: 0;
  min-height: -webkit-fill-available;
  min-height: 100vh;
  opacity: ${({ $isVisible: t }) => t ? 1 : 0};
  position: fixed;
  top: 0;
  transition: opacity
    ${({ $transitionDuration: t }) => t ? `${t}ms` : "0.2s"}
    ease-in;
  width: 100vw;
  z-index: 999999;

  ${({ $isVisible: t = !1 }) => !t && `
    pointer-events: none;
    touch-action: none;
    `}
`, Pn = te.div`
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  bottom: 0;
  color: black;
  filter: brightness(1.1);
  left: 0;
  margin: 0 8px 10px;
  overflow: hidden;
  position: fixed;
  transform: translateY(calc(100% + 10px));
  transition: transform
    ${({ $transitionDuration: t }) => t ? `${t}ms` : "0.4s"}
    cubic-bezier(0.4, 0.24, 0.3, 1);
  width: calc(100vw - 16px);
  z-index: 999999;

  @media (prefers-color-scheme: dark) {
    & {
      background: rgba(10, 10, 10, 0.5);
      color: rgba(235, 235, 245, 0.6);
    }
  }

  ${({ $isVisible: t = !1 }) => t && `
    transform: translateY(0);
    display: block;
    `}
`, _n = te.div`
  align-items: center;
  border-bottom: 1px solid rgba(60, 60, 67, 0.29);
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  border-width: 0.5px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 13px 16px;

  @media (prefers-color-scheme: dark) {
    & {
      border-color: rgba(140, 140, 140, 0.7);
    }
  }
`, kn = te.p`
  color: black;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.125;
  margin: 0;
  padding: 0;

  @media (prefers-color-scheme: dark) {
    & {
      color: white;
    }
  }
`, Cn = te.button`
  background: transparent;
  border: 0;
  color: rgba(0, 85, 179, 1);
  font-size: 16px;
  margin: 0;
  padding: 0;

  @media (prefers-color-scheme: dark) {
    & {
      color: rgba(9, 132, 255, 1);
    }
  }
`, Rn = te.div`
  display: flex;
  width: 100%;
`, In = te.div`
  border-bottom: 1px solid rgba(60, 60, 67, 0.29);
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  border-width: 0.5px;
  color: inherit;
  margin: 0 16px;
  padding: 16px;
  text-align: left;
  width: 100%;

  @media (prefers-color-scheme: dark) {
    & {
      border-color: rgba(140, 140, 140, 0.7);
    }
  }
`, jn = te(Sn).attrs({
  viewBox: "55 0 512 512"
})`
  color: rgba(0, 85, 179, 1);
  height: 44px;
  margin-right: 15px;
  width: 44px;
  flex-shrink: 0;

  @media (prefers-color-scheme: dark) {
    & {
      color: rgba(9, 132, 255, 1);
    }
  }
`, An = te(Tn)`
  color: black;
  height: 34px;
  margin-right: 25px;
  width: 34px;
  flex-shrink: 0;

  @media (prefers-color-scheme: dark) {
    & {
      color: white;
    }
  }
`, hr = te.p`
  color: black;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  font-size: 13px;
  line-height: 17px;
  margin: 0;
  padding: 0;

  ${({ $bold: t = !1 }) => t && `
  font-weight: 600;
  `}

  @media (prefers-color-scheme: dark) {
    & {
      border-color: rgba(235, 235, 245, 0.6);
      color: rgba(235, 235, 245, 0.6);
    }
  }
`, Vn = te.div`
  color: inherit;
  margin: 0 16px;
  padding: 16px;
`, Lr = te.div`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  text-align: left;
  margin-bottom: 16px;

  &:last-of-type {
    margin-bottom: 0;
  }
`, Mn = ({
  className: t,
  copyAddHomeButtonLabel: e,
  copyBody: r,
  copyClosePrompt: i,
  copyShareButtonLabel: o,
  copyTitle: d,
  delay: m,
  onAfterDismiss: w,
  transitionDuration: g
}) => {
  const [W, R] = cr(!m), j = Mr(), a = Mr();
  mn(), fn(() => R(!0), m && !W ? m : null);
  const l = () => R(!1);
  return /* @__PURE__ */ L.jsxs(L.Fragment, { children: [
    /* @__PURE__ */ L.jsx(
      xn,
      {
        "data-testid": "prompt-overlay",
        "aria-label": "Close",
        role: "button",
        onClick: l,
        $isVisible: W,
        $transitionDuration: g && g / 2
      }
    ),
    /* @__PURE__ */ L.jsxs(
      Pn,
      {
        className: t,
        "data-testid": "prompt-wrapper",
        "aria-describedby": j,
        "aria-labelledby": a,
        role: "dialog",
        $isVisible: W,
        onTransitionEnd: (s) => {
          w && !W && w(s);
        },
        $transitionDuration: g,
        children: [
          /* @__PURE__ */ L.jsxs(_n, { children: [
            /* @__PURE__ */ L.jsx(kn, { id: a, children: d }),
            /* @__PURE__ */ L.jsx(
              Cn,
              {
                "data-testid": "prompt-dismiss-button",
                onClick: l,
                children: i
              }
            )
          ] }),
          /* @__PURE__ */ L.jsx(Rn, { children: /* @__PURE__ */ L.jsx(In, { children: /* @__PURE__ */ L.jsx(hr, { id: j, children: r }) }) }),
          /* @__PURE__ */ L.jsxs(Vn, { children: [
            /* @__PURE__ */ L.jsxs(Lr, { children: [
              /* @__PURE__ */ L.jsx(jn, {}),
              /* @__PURE__ */ L.jsx(hr, { $bold: !0, children: o })
            ] }),
            /* @__PURE__ */ L.jsxs(Lr, { children: [
              /* @__PURE__ */ L.jsx(An, {}),
              /* @__PURE__ */ L.jsx(hr, { $bold: !0, children: e })
            ] })
          ] })
        ]
      }
    )
  ] });
};
var b = {}, Er = { exports: {} };
(function(t, e) {
  (function(r, i) {
    var o = "1.0.38", d = "", m = "?", w = "function", g = "undefined", W = "object", R = "string", j = "major", a = "model", l = "name", s = "type", u = "vendor", f = "version", N = "architecture", V = "console", S = "mobile", O = "tablet", U = "smarttv", se = "wearable", De = "embedded", Ue = 500, ve = "Amazon", be = "Apple", Ze = "ASUS", Be = "BlackBerry", B = "Browser", Z = "Chrome", me = "Edge", pe = "Firefox", we = "Google", Le = "Huawei", Pe = "LG", _e = "Microsoft", ze = "Motorola", le = "Opera", ge = "Samsung", Qe = "Sharp", ke = "Sony", he = "Xiaomi", ye = "Zebra", Ee = "Facebook", Ce = "Chromium OS", Oe = "Mac OS", vr = function(T, k) {
      var p = {};
      for (var I in T)
        k[I] && k[I].length % 2 === 0 ? p[I] = k[I].concat(T[I]) : p[I] = T[I];
      return p;
    }, Se = function(T) {
      for (var k = {}, p = 0; p < T.length; p++)
        k[T[p].toUpperCase()] = T[p];
      return k;
    }, er = function(T, k) {
      return typeof T === R ? Te(k).indexOf(Te(T)) !== -1 : !1;
    }, Te = function(T) {
      return T.toLowerCase();
    }, Re = function(T) {
      return typeof T === R ? T.replace(/[^\d\.]/g, d).split(".")[0] : i;
    }, ae = function(T, k) {
      if (typeof T === R)
        return T = T.replace(/^\s\s*/, d), typeof k === g ? T : T.substring(0, Ue);
    }, ue = function(T, k) {
      for (var p = 0, I, Q, J, P, h, ee; p < k.length && !h; ) {
        var Ye = k[p], nr = k[p + 1];
        for (I = Q = 0; I < Ye.length && !h && Ye[I]; )
          if (h = Ye[I++].exec(T), h)
            for (J = 0; J < nr.length; J++)
              ee = h[++Q], P = nr[J], typeof P === W && P.length > 0 ? P.length === 2 ? typeof P[1] == w ? this[P[0]] = P[1].call(this, ee) : this[P[0]] = P[1] : P.length === 3 ? typeof P[1] === w && !(P[1].exec && P[1].test) ? this[P[0]] = ee ? P[1].call(this, ee, P[2]) : i : this[P[0]] = ee ? ee.replace(P[1], P[2]) : i : P.length === 4 && (this[P[0]] = ee ? P[3].call(this, ee.replace(P[1], P[2])) : i) : this[P] = ee || i;
        p += 2;
      }
    }, Ie = function(T, k) {
      for (var p in k)
        if (typeof k[p] === W && k[p].length > 0) {
          for (var I = 0; I < k[p].length; I++)
            if (er(k[p][I], T))
              return p === m ? i : p;
        } else if (er(k[p], T))
          return p === m ? i : p;
      return T;
    }, je = { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }, rr = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, tr = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [f, [l, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [f, [l, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [l, f], [/opios[\/ ]+([\w\.]+)/i], [f, [l, le + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [f, [l, le + " GX"]], [/\bopr\/([\w\.]+)/i], [f, [l, le]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [f, [l, "Baidu"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [l, f], [/\bddg\/([\w\.]+)/i], [f, [l, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [f, [l, "UC" + B]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [f, [l, "WeChat"]], [/konqueror\/([\w\.]+)/i], [f, [l, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [f, [l, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [f, [l, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [f, [l, "Smart Lenovo " + B]], [/(avast|avg)\/([\w\.]+)/i], [[l, /(.+)/, "$1 Secure " + B], f], [/\bfocus\/([\w\.]+)/i], [f, [l, pe + " Focus"]], [/\bopt\/([\w\.]+)/i], [f, [l, le + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [f, [l, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [f, [l, "Dolphin"]], [/coast\/([\w\.]+)/i], [f, [l, le + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [f, [l, "MIUI " + B]], [/fxios\/([-\w\.]+)/i], [f, [l, pe]], [/\bqihu|(qi?ho?o?|360)browser/i], [[l, "360 " + B]], [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i], [[l, /(.+)/, "$1 " + B], f], [/samsungbrowser\/([\w\.]+)/i], [f, [l, ge + " Internet"]], [/(comodo_dragon)\/([\w\.]+)/i], [[l, /_/g, " "], f], [/metasr[\/ ]?([\d\.]+)/i], [f, [l, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[l, "Sogou Mobile"], f], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i], [l, f], [/(lbbrowser)/i, /\[(linkedin)app\]/i], [l], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[l, Ee], f], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [l, f], [/\bgsa\/([\w\.]+) .*safari\//i], [f, [l, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [f, [l, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [f, [l, Z + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[l, Z + " WebView"], f], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [f, [l, "Android " + B]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [l, f], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [f, [l, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [f, l], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [l, [f, Ie, je]], [/(webkit|khtml)\/([\w\.]+)/i], [l, f], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[l, "Netscape"], f], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [f, [l, pe + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [l, f], [/(cobalt)\/([\w\.]+)/i], [l, [f, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[N, "amd64"]], [/(ia32(?=;))/i], [[N, Te]], [/((?:i[346]|x)86)[;\)]/i], [[N, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[N, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[N, "armhf"]], [/windows (ce|mobile); ppc;/i], [[N, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[N, /ower/, d, Te]], [/(sun4\w)[;\)]/i], [[N, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[N, Te]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [a, [u, ge], [s, O]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [a, [u, ge], [s, S]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [a, [u, be], [s, S]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [a, [u, be], [s, O]], [/(macintosh);/i], [a, [u, be]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [a, [u, Qe], [s, S]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [a, [u, Le], [s, O]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [a, [u, Le], [s, S]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[a, /_/g, " "], [u, he], [s, S]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[a, /_/g, " "], [u, he], [s, O]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [a, [u, "OPPO"], [s, S]], [/\b(opd2\d{3}a?) bui/i], [a, [u, "OPPO"], [s, O]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [a, [u, "Vivo"], [s, S]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [a, [u, "Realme"], [s, S]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [a, [u, ze], [s, S]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [a, [u, ze], [s, O]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [a, [u, Pe], [s, O]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [a, [u, Pe], [s, S]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [a, [u, "Lenovo"], [s, O]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[a, /_/g, " "], [u, "Nokia"], [s, S]], [/(pixel c)\b/i], [a, [u, we], [s, O]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [a, [u, we], [s, S]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [a, [u, ke], [s, S]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[a, "Xperia Tablet"], [u, ke], [s, O]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [a, [u, "OnePlus"], [s, S]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [a, [u, ve], [s, O]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[a, /(.+)/g, "Fire Phone $1"], [u, ve], [s, S]], [/(playbook);[-\w\),; ]+(rim)/i], [a, u, [s, O]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [a, [u, Be], [s, S]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [a, [u, Ze], [s, O]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [a, [u, Ze], [s, S]], [/(nexus 9)/i], [a, [u, "HTC"], [s, O]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [u, [a, /_/g, " "], [s, S]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [a, [u, "Acer"], [s, O]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [a, [u, "Meizu"], [s, S]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [a, [u, "Ulefone"], [s, S]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [u, a, [s, S]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [u, a, [s, O]], [/(surface duo)/i], [a, [u, _e], [s, O]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [a, [u, "Fairphone"], [s, S]], [/(u304aa)/i], [a, [u, "AT&T"], [s, S]], [/\bsie-(\w*)/i], [a, [u, "Siemens"], [s, S]], [/\b(rct\w+) b/i], [a, [u, "RCA"], [s, O]], [/\b(venue[\d ]{2,7}) b/i], [a, [u, "Dell"], [s, O]], [/\b(q(?:mv|ta)\w+) b/i], [a, [u, "Verizon"], [s, O]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [a, [u, "Barnes & Noble"], [s, O]], [/\b(tm\d{3}\w+) b/i], [a, [u, "NuVision"], [s, O]], [/\b(k88) b/i], [a, [u, "ZTE"], [s, O]], [/\b(nx\d{3}j) b/i], [a, [u, "ZTE"], [s, S]], [/\b(gen\d{3}) b.+49h/i], [a, [u, "Swiss"], [s, S]], [/\b(zur\d{3}) b/i], [a, [u, "Swiss"], [s, O]], [/\b((zeki)?tb.*\b) b/i], [a, [u, "Zeki"], [s, O]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[u, "Dragon Touch"], a, [s, O]], [/\b(ns-?\w{0,9}) b/i], [a, [u, "Insignia"], [s, O]], [/\b((nxa|next)-?\w{0,9}) b/i], [a, [u, "NextBook"], [s, O]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[u, "Voice"], a, [s, S]], [/\b(lvtel\-)?(v1[12]) b/i], [[u, "LvTel"], a, [s, S]], [/\b(ph-1) /i], [a, [u, "Essential"], [s, S]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [a, [u, "Envizen"], [s, O]], [/\b(trio[-\w\. ]+) b/i], [a, [u, "MachSpeed"], [s, O]], [/\btu_(1491) b/i], [a, [u, "Rotor"], [s, O]], [/(shield[\w ]+) b/i], [a, [u, "Nvidia"], [s, O]], [/(sprint) (\w+)/i], [u, a, [s, S]], [/(kin\.[onetw]{3})/i], [[a, /\./g, " "], [u, _e], [s, S]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [a, [u, ye], [s, O]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [a, [u, ye], [s, S]], [/smart-tv.+(samsung)/i], [u, [s, U]], [/hbbtv.+maple;(\d+)/i], [[a, /^/, "SmartTV"], [u, ge], [s, U]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[u, Pe], [s, U]], [/(apple) ?tv/i], [u, [a, be + " TV"], [s, U]], [/crkey/i], [[a, Z + "cast"], [u, we], [s, U]], [/droid.+aft(\w+)( bui|\))/i], [a, [u, ve], [s, U]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [a, [u, Qe], [s, U]], [/(bravia[\w ]+)( bui|\))/i], [a, [u, ke], [s, U]], [/(mitv-\w{5}) bui/i], [a, [u, he], [s, U]], [/Hbbtv.*(technisat) (.*);/i], [u, a, [s, U]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[u, ae], [a, ae], [s, U]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[s, U]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [u, a, [s, V]], [/droid.+; (shield) bui/i], [a, [u, "Nvidia"], [s, V]], [/(playstation [345portablevi]+)/i], [a, [u, ke], [s, V]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [a, [u, _e], [s, V]], [/((pebble))app/i], [u, a, [s, se]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [a, [u, be], [s, se]], [/droid.+; (glass) \d/i], [a, [u, we], [s, se]], [/droid.+; (wt63?0{2,3})\)/i], [a, [u, ye], [s, se]], [/(quest( \d| pro)?)/i], [a, [u, Ee], [s, se]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [u, [s, De]], [/(aeobc)\b/i], [a, [u, ve], [s, De]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [a, [s, S]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [a, [s, O]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[s, O]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[s, S]], [/(android[-\w\. ]{0,9});.+buil/i], [a, [u, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [f, [l, me + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [f, [l, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [l, f], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [f, l]], os: [[/microsoft (windows) (vista|xp)/i], [l, f], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [l, [f, Ie, rr]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[f, Ie, rr], [l, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[f, /_/g, "."], [l, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[l, Oe], [f, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [f, l], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [l, f], [/\(bb(10);/i], [f, [l, Be]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [f, [l, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [f, [l, pe + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [f, [l, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [f, [l, "watchOS"]], [/crkey\/([\d\.]+)/i], [f, [l, Z + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[l, Ce], f], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [l, f], [/(sunos) ?([\w\.\d]*)/i], [[l, "Solaris"], f], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [l, f]] }, $ = function(T, k) {
      if (typeof T === W && (k = T, T = i), !(this instanceof $))
        return new $(T, k).getResult();
      var p = typeof r !== g && r.navigator ? r.navigator : i, I = T || (p && p.userAgent ? p.userAgent : d), Q = p && p.userAgentData ? p.userAgentData : i, J = k ? vr(tr, k) : tr, P = p && p.userAgent == I;
      return this.getBrowser = function() {
        var h = {};
        return h[l] = i, h[f] = i, ue.call(h, I, J.browser), h[j] = Re(h[f]), P && p && p.brave && typeof p.brave.isBrave == w && (h[l] = "Brave"), h;
      }, this.getCPU = function() {
        var h = {};
        return h[N] = i, ue.call(h, I, J.cpu), h;
      }, this.getDevice = function() {
        var h = {};
        return h[u] = i, h[a] = i, h[s] = i, ue.call(h, I, J.device), P && !h[s] && Q && Q.mobile && (h[s] = S), P && h[a] == "Macintosh" && p && typeof p.standalone !== g && p.maxTouchPoints && p.maxTouchPoints > 2 && (h[a] = "iPad", h[s] = O), h;
      }, this.getEngine = function() {
        var h = {};
        return h[l] = i, h[f] = i, ue.call(h, I, J.engine), h;
      }, this.getOS = function() {
        var h = {};
        return h[l] = i, h[f] = i, ue.call(h, I, J.os), P && !h[l] && Q && Q.platform && Q.platform != "Unknown" && (h[l] = Q.platform.replace(/chrome os/i, Ce).replace(/macos/i, Oe)), h;
      }, this.getResult = function() {
        return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
      }, this.getUA = function() {
        return I;
      }, this.setUA = function(h) {
        return I = typeof h === R && h.length > Ue ? ae(h, Ue) : h, this;
      }, this.setUA(I), this;
    };
    $.VERSION = o, $.BROWSER = Se([l, f, j]), $.CPU = Se([N]), $.DEVICE = Se([a, u, s, V, S, U, O, se, De]), $.ENGINE = $.OS = Se([l, f]), t.exports && (e = t.exports = $), e.UAParser = $;
    var ce = typeof r !== g && (r.jQuery || r.Zepto);
    if (ce && !ce.ua) {
      var Ae = new $();
      ce.ua = Ae.getResult(), ce.ua.get = function() {
        return Ae.getUA();
      }, ce.ua.set = function(T) {
        Ae.setUA(T);
        var k = Ae.getResult();
        for (var p in k)
          ce.ua[p] = k[p];
      };
    }
  })(typeof window == "object" ? window : He);
})(Er, Er.exports);
var Wn = Er.exports;
Object.defineProperty(b, "__esModule", { value: !0 });
function Fn(t) {
  return t && typeof t == "object" && "default" in t ? t.default : t;
}
var Y = oe, M = Fn(Y), Jr = Wn, de = new Jr(), q = de.getBrowser(), Nn = de.getCPU(), X = de.getDevice(), xr = de.getEngine(), fe = de.getOS(), Je = de.getUA(), Xr = function(e) {
  return de.setUA(e);
}, Xe = function(e) {
  if (!e) {
    console.error("No userAgent string was provided");
    return;
  }
  var r = new Jr(e);
  return {
    UA: r,
    browser: r.getBrowser(),
    cpu: r.getCPU(),
    device: r.getDevice(),
    engine: r.getEngine(),
    os: r.getOS(),
    ua: r.getUA(),
    setUserAgent: function(o) {
      return r.setUA(o);
    }
  };
}, Zr = /* @__PURE__ */ Object.freeze({
  ClientUAInstance: de,
  browser: q,
  cpu: Nn,
  device: X,
  engine: xr,
  os: fe,
  ua: Je,
  setUa: Xr,
  parseUserAgent: Xe
});
function zr(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function Dn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? zr(Object(r), !0).forEach(function(i) {
      zn(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : zr(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function Ge(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ge = function(e) {
    return typeof e;
  } : Ge = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ge(t);
}
function Un(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Bn(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function Ln(t, e, r) {
  return e && Bn(t.prototype, e), t;
}
function zn(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function Or() {
  return Or = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Or.apply(this, arguments);
}
function Yn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), e && Tr(t, e);
}
function Sr(t) {
  return Sr = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Sr(t);
}
function Tr(t, e) {
  return Tr = Object.setPrototypeOf || function(i, o) {
    return i.__proto__ = o, i;
  }, Tr(t, e);
}
function qn(t, e) {
  if (t == null) return {};
  var r = {}, i = Object.keys(t), o, d;
  for (d = 0; d < i.length; d++)
    o = i[d], !(e.indexOf(o) >= 0) && (r[o] = t[o]);
  return r;
}
function ne(t, e) {
  if (t == null) return {};
  var r = qn(t, e), i, o;
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(t);
    for (o = 0; o < d.length; o++)
      i = d[o], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
  }
  return r;
}
function ir(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function $n(t, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ir(t);
}
function Hn(t, e) {
  return Gn(t) || Kn(t, e) || Jn(t, e) || Xn();
}
function Gn(t) {
  if (Array.isArray(t)) return t;
}
function Kn(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var i = [], o = !0, d = !1, m, w;
    try {
      for (r = r.call(t); !(o = (m = r.next()).done) && (i.push(m.value), !(e && i.length === e)); o = !0)
        ;
    } catch (g) {
      d = !0, w = g;
    } finally {
      try {
        !o && r.return != null && r.return();
      } finally {
        if (d) throw w;
      }
    }
    return i;
  }
}
function Jn(t, e) {
  if (t) {
    if (typeof t == "string") return Yr(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Yr(t, e);
  }
}
function Yr(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++) i[r] = t[r];
  return i;
}
function Xn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var z = {
  Mobile: "mobile",
  Tablet: "tablet",
  SmartTv: "smarttv",
  Console: "console",
  Wearable: "wearable",
  Embedded: "embedded",
  Browser: void 0
}, K = {
  Chrome: "Chrome",
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: "IE",
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: "Samsung Browser"
}, Ne = {
  IOS: "iOS",
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MAC_OS: "Mac OS"
}, Zn = {
  isMobile: !1,
  isTablet: !1,
  isBrowser: !1,
  isSmartTV: !1,
  isConsole: !1,
  isWearable: !1
}, Qn = function(e) {
  switch (e) {
    case z.Mobile:
      return {
        isMobile: !0
      };
    case z.Tablet:
      return {
        isTablet: !0
      };
    case z.SmartTv:
      return {
        isSmartTV: !0
      };
    case z.Console:
      return {
        isConsole: !0
      };
    case z.Wearable:
      return {
        isWearable: !0
      };
    case z.Browser:
      return {
        isBrowser: !0
      };
    case z.Embedded:
      return {
        isEmbedded: !0
      };
    default:
      return Zn;
  }
}, ei = function(e) {
  return Xr(e);
}, E = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
  return e || r;
}, Pr = function() {
  return typeof window < "u" && (window.navigator || navigator) ? window.navigator || navigator : !1;
}, _r = function(e) {
  var r = Pr();
  return r && r.platform && (r.platform.indexOf(e) !== -1 || r.platform === "MacIntel" && r.maxTouchPoints > 1 && !window.MSStream);
}, ri = function(e, r, i, o, d) {
  return {
    isBrowser: e,
    browserMajorVersion: E(r.major),
    browserFullVersion: E(r.version),
    browserName: E(r.name),
    engineName: E(i.name),
    engineVersion: E(i.version),
    osName: E(o.name),
    osVersion: E(o.version),
    userAgent: E(d)
  };
}, qr = function(e, r, i, o) {
  return Dn({}, e, {
    vendor: E(r.vendor),
    model: E(r.model),
    os: E(i.name),
    osVersion: E(i.version),
    ua: E(o)
  });
}, ti = function(e, r, i, o) {
  return {
    isSmartTV: e,
    engineName: E(r.name),
    engineVersion: E(r.version),
    osName: E(i.name),
    osVersion: E(i.version),
    userAgent: E(o)
  };
}, ni = function(e, r, i, o) {
  return {
    isConsole: e,
    engineName: E(r.name),
    engineVersion: E(r.version),
    osName: E(i.name),
    osVersion: E(i.version),
    userAgent: E(o)
  };
}, ii = function(e, r, i, o) {
  return {
    isWearable: e,
    engineName: E(r.name),
    engineVersion: E(r.version),
    osName: E(i.name),
    osVersion: E(i.version),
    userAgent: E(o)
  };
}, oi = function(e, r, i, o, d) {
  return {
    isEmbedded: e,
    vendor: E(r.vendor),
    model: E(r.model),
    engineName: E(i.name),
    engineVersion: E(i.version),
    osName: E(o.name),
    osVersion: E(o.version),
    userAgent: E(d)
  };
};
function ai(t) {
  var e = t ? Xe(t) : Zr, r = e.device, i = e.browser, o = e.engine, d = e.os, m = e.ua, w = Qn(r.type), g = w.isBrowser, W = w.isMobile, R = w.isTablet, j = w.isSmartTV, a = w.isConsole, l = w.isWearable, s = w.isEmbedded;
  if (g)
    return ri(g, i, o, d, m);
  if (j)
    return ti(j, o, d, m);
  if (a)
    return ni(a, o, d, m);
  if (W || R)
    return qr(w, r, d, m);
  if (l)
    return ii(l, o, d, m);
  if (s)
    return oi(s, r, o, d, m);
}
var Qr = function(e) {
  var r = e.type;
  return r === z.Mobile;
}, et = function(e) {
  var r = e.type;
  return r === z.Tablet;
}, rt = function(e) {
  var r = e.type;
  return r === z.Mobile || r === z.Tablet;
}, tt = function(e) {
  var r = e.type;
  return r === z.SmartTv;
}, sr = function(e) {
  var r = e.type;
  return r === z.Browser;
}, nt = function(e) {
  var r = e.type;
  return r === z.Wearable;
}, it = function(e) {
  var r = e.type;
  return r === z.Console;
}, ot = function(e) {
  var r = e.type;
  return r === z.Embedded;
}, at = function(e) {
  var r = e.vendor;
  return E(r);
}, st = function(e) {
  var r = e.model;
  return E(r);
}, lt = function(e) {
  var r = e.type;
  return E(r, "browser");
}, ut = function(e) {
  var r = e.name;
  return r === Ne.Android;
}, ct = function(e) {
  var r = e.name;
  return r === Ne.Windows;
}, dt = function(e) {
  var r = e.name;
  return r === Ne.MAC_OS;
}, ft = function(e) {
  var r = e.name;
  return r === Ne.WindowsPhone;
}, vt = function(e) {
  var r = e.name;
  return r === Ne.IOS;
}, bt = function(e) {
  var r = e.version;
  return E(r);
}, mt = function(e) {
  var r = e.name;
  return E(r);
}, pt = function(e) {
  var r = e.name;
  return r === K.Chrome;
}, wt = function(e) {
  var r = e.name;
  return r === K.Firefox;
}, gt = function(e) {
  var r = e.name;
  return r === K.Chromium;
}, lr = function(e) {
  var r = e.name;
  return r === K.Edge;
}, ht = function(e) {
  var r = e.name;
  return r === K.Yandex;
}, yt = function(e) {
  var r = e.name;
  return r === K.Safari || r === K.MobileSafari;
}, Et = function(e) {
  var r = e.name;
  return r === K.MobileSafari;
}, Ot = function(e) {
  var r = e.name;
  return r === K.Opera;
}, St = function(e) {
  var r = e.name;
  return r === K.InternetExplorer || r === K.Ie;
}, Tt = function(e) {
  var r = e.name;
  return r === K.MIUI;
}, xt = function(e) {
  var r = e.name;
  return r === K.SamsungBrowser;
}, Pt = function(e) {
  var r = e.version;
  return E(r);
}, _t = function(e) {
  var r = e.major;
  return E(r);
}, kt = function(e) {
  var r = e.name;
  return E(r);
}, Ct = function(e) {
  var r = e.name;
  return E(r);
}, Rt = function(e) {
  var r = e.version;
  return E(r);
}, It = function() {
  var e = Pr(), r = e && e.userAgent && e.userAgent.toLowerCase();
  return typeof r == "string" ? /electron/.test(r) : !1;
}, Fe = function(e) {
  return typeof e == "string" && e.indexOf("Edg/") !== -1;
}, jt = function() {
  var e = Pr();
  return e && (/iPad|iPhone|iPod/.test(e.platform) || e.platform === "MacIntel" && e.maxTouchPoints > 1) && !window.MSStream;
}, ie = function() {
  return _r("iPad");
}, At = function() {
  return _r("iPhone");
}, Vt = function() {
  return _r("iPod");
}, Mt = function(e) {
  return E(e);
};
function Wt(t) {
  var e = t || Zr, r = e.device, i = e.browser, o = e.os, d = e.engine, m = e.ua;
  return {
    isSmartTV: tt(r),
    isConsole: it(r),
    isWearable: nt(r),
    isEmbedded: ot(r),
    isMobileSafari: Et(i) || ie(),
    isChromium: gt(i),
    isMobile: rt(r) || ie(),
    isMobileOnly: Qr(r),
    isTablet: et(r) || ie(),
    isBrowser: sr(r),
    isDesktop: sr(r),
    isAndroid: ut(o),
    isWinPhone: ft(o),
    isIOS: vt(o) || ie(),
    isChrome: pt(i),
    isFirefox: wt(i),
    isSafari: yt(i),
    isOpera: Ot(i),
    isIE: St(i),
    osVersion: bt(o),
    osName: mt(o),
    fullBrowserVersion: Pt(i),
    browserVersion: _t(i),
    browserName: kt(i),
    mobileVendor: at(r),
    mobileModel: st(r),
    engineName: Ct(d),
    engineVersion: Rt(d),
    getUA: Mt(m),
    isEdge: lr(i) || Fe(m),
    isYandex: ht(i),
    deviceType: lt(r),
    isIOS13: jt(),
    isIPad13: ie(),
    isIPhone13: At(),
    isIPod13: Vt(),
    isElectron: It(),
    isEdgeChromium: Fe(m),
    isLegacyEdge: lr(i) && !Fe(m),
    isWindows: ct(o),
    isMacOs: dt(o),
    isMIUI: Tt(i),
    isSamsungBrowser: xt(i)
  };
}
var Ft = tt(X), Nt = it(X), Dt = nt(X), si = ot(X), li = Et(q) || ie(), ui = gt(q), fr = rt(X) || ie(), Ut = Qr(X), Bt = et(X) || ie(), Lt = sr(X), ci = sr(X), zt = ut(fe), Yt = ft(fe), qt = vt(fe) || ie(), di = pt(q), fi = wt(q), vi = yt(q), bi = Ot(q), $t = St(q), mi = bt(fe), pi = mt(fe), wi = Pt(q), gi = _t(q), hi = kt(q), yi = at(X), Ei = st(X), Oi = Ct(xr), Si = Rt(xr), Ti = Mt(Je), xi = lr(q) || Fe(Je), Pi = ht(q), _i = lt(X), ki = jt(), Ci = ie(), Ri = At(), Ii = Vt(), ji = It(), Ai = Fe(Je), Vi = lr(q) && !Fe(Je), Mi = ct(fe), Wi = dt(fe), Fi = Tt(q), Ni = xt(q), Di = function(e) {
  if (!e || typeof e != "string") {
    console.error("No valid user agent string was provided");
    return;
  }
  var r = Xe(e), i = r.device, o = r.browser, d = r.os, m = r.engine, w = r.ua;
  return Wt({
    device: i,
    browser: o,
    os: d,
    engine: m,
    ua: w
  });
}, Ui = function(e) {
  var r = e.renderWithFragment, i = e.children, o = ne(e, ["renderWithFragment", "children"]);
  return zt ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", o, i) : null;
}, Bi = function(e) {
  var r = e.renderWithFragment, i = e.children, o = ne(e, ["renderWithFragment", "children"]);
  return Lt ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", o, i) : null;
}, Li = function(e) {
  var r = e.renderWithFragment, i = e.children, o = ne(e, ["renderWithFragment", "children"]);
  return $t ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", o, i) : null;
}, zi = function(e) {
  var r = e.renderWithFragment, i = e.children, o = ne(e, ["renderWithFragment", "children"]);
  return qt ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", o, i) : null;
}, Yi = function(e) {
  var r = e.renderWithFragment, i = e.children, o = ne(e, ["renderWithFragment", "children"]);
  return fr ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", o, i) : null;
}, qi = function(e) {
  var r = e.renderWithFragment, i = e.children, o = ne(e, ["renderWithFragment", "children"]);
  return Bt ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", o, i) : null;
}, $i = function(e) {
  var r = e.renderWithFragment, i = e.children, o = ne(e, ["renderWithFragment", "children"]);
  return Yt ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", o, i) : null;
}, Hi = function(e) {
  var r = e.renderWithFragment, i = e.children;
  e.viewClassName, e.style;
  var o = ne(e, ["renderWithFragment", "children", "viewClassName", "style"]);
  return Ut ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", o, i) : null;
}, Gi = function(e) {
  var r = e.renderWithFragment, i = e.children, o = ne(e, ["renderWithFragment", "children"]);
  return Ft ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", o, i) : null;
}, Ki = function(e) {
  var r = e.renderWithFragment, i = e.children, o = ne(e, ["renderWithFragment", "children"]);
  return Nt ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", o, i) : null;
}, Ji = function(e) {
  var r = e.renderWithFragment, i = e.children, o = ne(e, ["renderWithFragment", "children"]);
  return Dt ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", o, i) : null;
}, Xi = function(e) {
  var r = e.renderWithFragment, i = e.children;
  e.viewClassName, e.style;
  var o = e.condition, d = ne(e, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
  return o ? r ? M.createElement(Y.Fragment, null, i) : M.createElement("div", d, i) : null;
};
function Zi(t) {
  return /* @__PURE__ */ function(e) {
    Yn(r, e);
    function r(i) {
      var o;
      return Un(this, r), o = $n(this, Sr(r).call(this, i)), o.isEventListenerAdded = !1, o.handleOrientationChange = o.handleOrientationChange.bind(ir(o)), o.onOrientationChange = o.onOrientationChange.bind(ir(o)), o.onPageLoad = o.onPageLoad.bind(ir(o)), o.state = {
        isLandscape: !1,
        isPortrait: !1
      }, o;
    }
    return Ln(r, [{
      key: "handleOrientationChange",
      value: function() {
        this.isEventListenerAdded || (this.isEventListenerAdded = !0);
        var o = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: o === 0,
          isLandscape: o === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function() {
        (typeof window > "u" ? "undefined" : Ge(window)) !== void 0 && fr && (this.isEventListenerAdded ? window.removeEventListener("load", this.onPageLoad, !1) : (this.handleOrientationChange(), window.addEventListener("load", this.onPageLoad, !1)), window.addEventListener("resize", this.onOrientationChange, !1));
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        window.removeEventListener("resize", this.onOrientationChange, !1);
      }
    }, {
      key: "render",
      value: function() {
        return M.createElement(t, Or({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]), r;
  }(M.Component);
}
function Qi() {
  var t = Y.useState(function() {
    var d = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: d === 0,
      isLandscape: d === 90,
      orientation: d === 0 ? "portrait" : "landscape"
    };
  }), e = Hn(t, 2), r = e[0], i = e[1], o = Y.useCallback(function() {
    var d = window.innerWidth > window.innerHeight ? 90 : 0, m = {
      isPortrait: d === 0,
      isLandscape: d === 90,
      orientation: d === 0 ? "portrait" : "landscape"
    };
    r.orientation !== m.orientation && i(m);
  }, [r.orientation]);
  return Y.useEffect(function() {
    return (typeof window > "u" ? "undefined" : Ge(window)) !== void 0 && fr && (o(), window.addEventListener("load", o, !1), window.addEventListener("resize", o, !1)), function() {
      window.removeEventListener("resize", o, !1), window.removeEventListener("load", o, !1);
    };
  }, [o]), r;
}
function Ht(t) {
  var e = t || window.navigator.userAgent;
  return Xe(e);
}
function eo(t) {
  var e = t || window.navigator.userAgent, r = Ht(e), i = Wt(r);
  return [i, r];
}
b.AndroidView = Ui;
b.BrowserTypes = K;
b.BrowserView = Bi;
b.ConsoleView = Ki;
b.CustomView = Xi;
b.IEView = Li;
b.IOSView = zi;
b.MobileOnlyView = Hi;
b.MobileView = Yi;
b.OsTypes = Ne;
b.SmartTVView = Gi;
b.TabletView = qi;
b.WearableView = Ji;
b.WinPhoneView = $i;
b.browserName = hi;
b.browserVersion = gi;
b.deviceDetect = ai;
b.deviceType = _i;
b.engineName = Oi;
b.engineVersion = Si;
b.fullBrowserVersion = wi;
b.getSelectorsByUserAgent = Di;
b.getUA = Ti;
b.isAndroid = zt;
b.isBrowser = Lt;
b.isChrome = di;
b.isChromium = ui;
b.isConsole = Nt;
b.isDesktop = ci;
b.isEdge = xi;
b.isEdgeChromium = Ai;
b.isElectron = ji;
b.isEmbedded = si;
b.isFirefox = fi;
b.isIE = $t;
b.isIOS = qt;
b.isIOS13 = ki;
b.isIPad13 = Ci;
b.isIPhone13 = Ri;
b.isIPod13 = Ii;
b.isLegacyEdge = Vi;
b.isMIUI = Fi;
b.isMacOs = Wi;
b.isMobile = fr;
b.isMobileOnly = Ut;
b.isMobileSafari = li;
b.isOpera = bi;
b.isSafari = vi;
b.isSamsungBrowser = Ni;
b.isSmartTV = Ft;
b.isTablet = Bt;
b.isWearable = Dt;
b.isWinPhone = Yt;
b.isWindows = Mi;
b.isYandex = Pi;
b.mobileModel = Ei;
b.mobileVendor = yi;
b.osName = pi;
b.osVersion = mi;
b.parseUserAgent = Xe;
b.setUserAgent = ei;
b.useDeviceData = Ht;
var ro = b.useDeviceSelectors = eo;
b.useMobileOrientation = Qi;
b.withOrientationChange = Zi;
const to = (t, e) => {
  const r = !!e && "standalone" in e && e.standalone;
  return t && !r;
}, no = ({
  setIosPwaPrompt: t,
  skipStorageUpdate: e = !1
}) => {
  const [{ isIOS: r, isIPad13: i }] = ro(window.navigator.userAgent);
  $r(() => {
    if (!e) {
      const o = to(r || i, window.navigator);
      t((d) => ({
        isiOS: o,
        visits: o && d ? d.visits + 1 : (d == null ? void 0 : d.visits) || 0
      }));
    }
  }, [t, r, i, e]);
}, io = "iosPwaPrompt", uo = ({
  className: t,
  copyAddHomeButtonLabel: e = "2) Press 'Add to Home Screen'.",
  copyBody: r = "This website has app functionality. Add it to your home screen to use it in fullscreen and while offline.",
  copyClosePrompt: i = "Cancel",
  copyShareButtonLabel: o = "1) Press the 'Share' button on the menu bar below.",
  copyTitle: d = "Add to Home Screen",
  delay: m = 1e3,
  isOpen: w = void 0,
  onClose: g = void 0,
  permanentlyHideOnDismiss: W = !0,
  promptLocalStorageKey: R = io,
  promptOnVisit: j = 1,
  skipStorageUpdate: a = !1,
  timesToShow: l = 1,
  transitionDuration: s = 400
}) => {
  const [u, f] = cr(!1), { shouldShowPrompt: N, setIosPwaPrompt: V } = ao({
    promptLocalStorageKey: R,
    promptOnVisit: j,
    timesToShow: l
  });
  no({
    setIosPwaPrompt: V,
    skipStorageUpdate: a
  });
  const S = We(
    (O) => {
      W && V(
        (U) => U && {
          ...U,
          visits: j + l
        }
      ), f(!0), g && g(O);
    },
    [
      g,
      W,
      j,
      V,
      l
    ]
  );
  return (!N || u || w === !1) && !w ? null : /* @__PURE__ */ L.jsx(
    Mn,
    {
      className: t,
      delay: m,
      copyTitle: d,
      copyBody: r,
      copyAddHomeButtonLabel: e,
      copyShareButtonLabel: o,
      copyClosePrompt: i,
      onAfterDismiss: S,
      transitionDuration: s
    }
  );
}, oo = (t, e) => vn(
  t,
  e ? void 0 : {
    isiOS: !1,
    visits: 0
  }
), ao = ({
  promptLocalStorageKey: t,
  promptOnVisit: e = 1,
  timesToShow: r = 1,
  withOutDefaults: i = !1
}) => {
  const [o, d] = oo(
    t,
    i
  ), m = o && o.visits >= e, w = o && o.visits < e + r;
  return {
    aboveMinVisits: m,
    belowMaxVisits: w,
    iosPwaPrompt: o,
    setIosPwaPrompt: d,
    shouldShowPrompt: (o == null ? void 0 : o.isiOS) && m && w
  };
};
export {
  Mn as Prompt,
  An as PromptAddToHomeIcon,
  Rn as PromptBody,
  Cn as PromptCancelButton,
  hr as PromptCopy,
  In as PromptDescription,
  _n as PromptHeader,
  Lr as PromptInstructionStep,
  Vn as PromptInstructions,
  io as PromptLocalStorageKey,
  xn as PromptOverlay,
  jn as PromptShareIcon,
  kn as PromptTitle,
  Pn as PromptWrapper,
  uo as PwaPrompt,
  oo as usePromptStorage,
  ao as useShouldShowPrompt,
  no as useUpdatePromptStorage
};
